import { makeStyles } from 'tss-react/mui'
import { navBarHeaderHeight } from '../../lib/Constants'

export const AccountSettingsPageClasses = makeStyles()(theme => {
  return {
    container: {
      padding: '0px 0px',
      margin: '0px 0px',
      maxWidth: '100%'
    },
    title: {
      '&.MuiTypography-root': {
        fontFamily: 'Rubik Bold',
        display: 'flex',
        color: theme.colors.white,
        padding: '24px 0px 32px 20px',
        fontWeight: 700,
        fontSize: '28px'
      }
    },
    titleBackground: {
      top: 0,
      left: 0,
      position: 'absolute',
      backgroundColor: theme.colors.accountSettings.bgBlue,
      height: '500px',
      width: '100%',
      maxWidth: '100%'
    },
    frontBoxes: {
      position: 'relative'
    }
  }
})

export const UpdateAccountInfoClasses = makeStyles()(theme => {
  return {
    title: {
      '&.MuiFormLabel-root': {
        letterSpacing: '1.5px',
        color: 'black',
        fontSize: '20px',
        fontWeight: '700',
        fontFamily: 'Rubik Bold',
        margin: '32px 0px 0px 0px'
      }
    },
    save: {
      textTransform: 'none',
      fontSize: '18px',
      font: 'Rubik',
      fontWeight: '700',
      color: theme.colors.backgroundColor,
      borderRadius: '100px',
      borderColor: theme.colors.textGray,
      width: '161px',
      height: '49px',
      backgroundColor: theme.colors.textGray,
      float: 'right',
      marginRight: 36
    },
    errorMessage: {
      color: theme.colors.gray,
      fontWeight: '400',
      fontSize: '12px'
    },
    avatar: {
      width: '140px',
      height: '140px'
    },
    photoPicker: {
      display: 'none'
    },
    photoPickerButton: {
      borderColor: 'transparent',
      color: theme.colors.basicDisabledButtonColor,
      fontSize: '10px',
      marginTop: '6px'
    },
    imageGroup: {
      alignItems: 'center',
      width: '313px'
    },
    drawerPaper: {
      maxHeight: `calc(100% - calc(${navBarHeaderHeight + ' + 12px'}))`,
      marginTop: navBarHeaderHeight,
      marginRight: '20px',
      width: '387px',
      borderRadius: '8px',
      overflow: 'auto',
      overflowX: 'hidden',
      zIndex: 1500,
      boxSizing: 'content-box',
      marginBottom: '20px',
      display: 'flex'
    },
    footer: {
      marginTop: '20px',
      height: '49px',
      width: '100%',
      display: 'flex',
      justifyContent: 'space-between'
    },
    drawerContainer: { height: '100%', position: 'relative' },
    drawerTitle: { alignItems: 'center', paddingLeft: '20px' },
    drawerContent: {
      '&.MuiGrid-root': {}
    },
    separator: {
      height: '52px',
      width: '1px',
      borderRightWidth: '1px',
      borderRightStyle: 'solid',
      borderColor: theme.colors.grayBorder,
      position: 'relative'
    },
    icon: {
      '.svg-inline--fa': {
        color: theme.colors.gray2
      }
    },
    redAsterisk: {
      '& .MuiInputLabel-asterisk': {
        color: theme.colors.red
      }
    },
    saveButton: {
      fontSize: '18px !important'
    },
    deleteButton: {
      alignSelf: 'flex-start',
      marginLeft: '20px',
      marginRight: '0',
      color: theme.colors.redError,
      textTransform: 'none',
      fontSize: '18px',
      fontWeight: '600',
      letterSpacing: '0.05em',
      lineHeight: '19px',
      padding: '10px',
      width: '120px'
    }
  }
})

export const freeFormInputStyles = makeStyles()(theme => ({
  root: {
    '& .MuiFilledInput-input': {
      border: `1px solid ${theme.colors.signInButton.background}`,
      color: `${theme.colors.text} !important`,
      backgroundColor: theme.colors.signInButton.background,
      width: '303px',
      borderRadius: '6px'
    },
    '.MuiInputAdornment-root': {
      color: `${theme.colors.text} !important`,
      paddingTop: '21px !important',
      paddingBottom: '4px !important'
    }
  }
}))

export const AccountInfoCardClasses = makeStyles()(theme => {
  return {
    card: {
      '&.MuiCard-root': {
        borderRadius: '10px',
        margin: '0px 15px 13px 20px',
        boxShadow: '6px 9px 43px rgba(216, 216, 216, 0.25)'
      }
    },
    box: {
      display: 'flex',
      justifyContent: 'space-between',
      marginLeft: '32px',
      marginRight: '10px',
      marginTop: '10px',
      marginBottom: '30px'
    },
    title: {
      '&.MuiTypography-root': {
        fontFamily: 'Rubik Bold',
        fontSize: '25.63px',
        fontWeight: '700',
        letterSpacing: '1px'
      }
    },
    editButton: {
      '& .MuiTypography-root': {
        color: theme.colors.settings.editButton,
        fontFamily: 'Rubik',
        fontWeight: '500',
        padding: 0,
        fontSize: '20.5px',
        textTransform: 'none'
      },
      '&.Mui-disabled': {
        '& .MuiTypography-root': {
          color: theme.colors.textGray
        }
      }
    },
    field: {
      '&.MuiTypography-root': {
        fontSize: '15px',
        fontWeight: '500',
        color: theme.colors.settings.fieldName
      }
    },
    namesInfo: {
      '&.MuiTypography-root': {
        border: `1px solid ${theme.colors.settings.border}`,
        borderRadius: '30px',
        fontSize: '15.38px',
        fontWeight: '400',
        color: theme.colors.black,
        marginBottom: '15px',
        wordWrap: 'break-word',
        padding: '5px 13px',
        minHeight: '32px',
        textTransform: 'capitalize'
      }
    },
    info: {
      '&.MuiTypography-root': {
        border: `1px solid ${theme.colors.settings.border}`,
        borderRadius: '30px',
        fontSize: '15.38px',
        fontWeight: '400',
        color: theme.colors.black,
        marginBottom: '15px',
        wordWrap: 'break-word',
        padding: '5px 13px',
        minHeight: '32px'
      }
    },
    passwordInfo: {
      '&.MuiTypography-root': {
        border: `1px solid ${theme.colors.settings.border}`,
        borderRadius: '30px',
        fontSize: '15.3px',
        fontWeight: '400',
        color: theme.colors.black,
        marginBottom: '15px',
        wordWrap: 'break-word',
        paddingLeft: '13px',
        paddingRight: '13px',
        paddingTop: '8px',
        minHeight: '32px'
      }
    },
    infoEmpty: {
      '&.MuiTypography-root': {
        border: `1px solid ${theme.colors.settings.border}`,
        borderRadius: '30px',
        fontSize: '15.3px',
        fontWeight: '400',
        color: theme.colors.textGray,
        marginBottom: '15px',
        wordWrap: 'break-word',
        padding: '5px 13px',
        minHeight: '32px'
      }
    },
    gridImg: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center'
    },
    avatar: {
      width: '140px',
      height: '140px'
    },
    content: {
      '&.MuiCardContent-root': {
        padding: '10px 0px 20px 32px'
      }
    }
  }
})

export const PhoneInputClasses = makeStyles()(theme => {
  return {
    root: {
      '& .MuiFilledInput-input': {
        fontFamily: 'Rubik',
        border: `1px solid ${theme.colors.signInButton.background}`,
        color: `${theme.colors.text} !important`,
        backgroundColor: theme.colors.signInButton.background,
        borderRadius: '6px',
        fontSize: '10.7px'
      },
      '& .MuiFilledInput-root': {
        backgroundColor: theme.colors.signInButton.background,
        borderRadius: '6px'
      },
      '& .MuiIconButton-sizeSmall': {
        marginLeft: '0px'
      },
      '& .MuiIconButton-sizeSmall:hover': {
        backgroundColor: theme.colors.signInButton.background
      },
      '& .MuiFilledInput-adornedEnd': {
        paddingRight: 0
      },
      '& .MuiFormLabel-root': {
        color: theme.colors.settings.fieldName,
        top: '4px',
        fontSize: '10.7px',
        fontWeight: '400',
        letterSpacing: '0.53px'
      },
      '& .Mui-focused': {
        color: theme.colors.tab.duedate
      },
      '& .MuiFormHelperText-root': {
        fontSize: '10px'
      },
      '& .MuiInputBase-input': {
        fontSize: '17.12px'
      },
      '& .MuiInputLabel-root.Mui-error': {
        color: `${theme.colors.fieldName} !important`
      },
      '.MuiInputAdornment-root': {
        paddingTop: '21px !important',
        paddingBottom: '4px !important'
      },
      '.MuiFormHelperText-root.Mui-error': {
        color: theme.colors.textButton
      }
    },
    input: {
      marginTop: 'unset',
      marginBottom: '12px'
    },
    label: {
      marginTop: 'unset',
      fontSize: 10,
      borderRadius: '8px',
      color: theme.colors.tab.duedate
    },
    textField: {
      height: '52px',
      backgroundColor: theme.colors.signInButton.background
    },
    icon: {
      color: theme.colors.company.iconColor,
      '& svg': {
        fontSize: '20px'
      },
      '&.MuiButtonBase-root': {
        padding: '0px'
      }
    },
    formControl: {
      '& .MuiFormControl-root': {
        margin: 0
      }
    }
  }
})

export const FreeFormClasses = makeStyles()(theme => ({
  root: {
    '& .MuiFilledInput-input': {
      fontFamily: 'Rubik',
      border: `1px solid ${theme.colors.signInButton.background}`,
      color: `${theme.colors.text} !important`,
      backgroundColor: theme.colors.signInButton.background,
      borderRadius: '6px',
      fontSize: '10.7px'
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.colors.signInButton.background,
      borderRadius: '6px'
    },
    '& .MuiIconButton-sizeSmall': {
      marginLeft: '0px'
    },
    '& .MuiIconButton-sizeSmall:hover': {
      backgroundColor: theme.colors.signInButton.background
    },
    '& .MuiFilledInput-adornedEnd': {
      paddingRight: 0
    },
    '& .MuiFormLabel-root': {
      color: theme.colors.settings.fieldName,
      top: '4px',
      fontSize: '10.7px',
      fontWeight: '400',
      letterSpacing: '0.53px'
    },
    '& .Mui-focused': {
      color: theme.colors.tab.duedate
    },
    '& .MuiFormHelperText-root': {
      fontSize: '10px'
    },
    '& .MuiInputBase-input': {
      fontSize: '17.12px'
    },
    '& .MuiInputLabel-root.Mui-required': {
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: `${theme.colors.fieldName} !important`
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: theme.colors.fieldName
    },
    '& .MuiFormLabel-asterisk': { color: theme.colors.gray },
    '.MuiInputAdornment-root': {
      paddingTop: '21px !important',
      paddingBottom: '4px !important'
    },
    '.MuiFormHelperText-root.Mui-error': {
      color: theme.colors.textButton
    },
    marginTop: 'unset',
    marginBottom: '12px',
    flex: 1
  },
  label: {
    marginTop: 'unset',
    fontSize: 10,
    borderRadius: '8px',
    color: theme.colors.tab.duedate
  },
  textField: {
    height: '52px',
    backgroundColor: theme.colors.signInButton.background
  },
  textFieldAnimation: {
    '& input': {
      '&.pac-target-input': {
        animationName: 'none'
      }
    }
  },
  icon: {
    color: theme.colors.closeIconColor,
    '& svg': {
      fontSize: '20px'
    },
    '&.MuiButtonBase-root': {
      padding: '0px'
    }
  },
  formControl: {
    '& .MuiFormControl-root': {
      margin: 0
    }
  }
}))

export const SelectorClasses = makeStyles()(theme => ({
  menuStyle: {
    maxHeight: 48 * 4.5 + 8
  },
  textField: {
    borderRadius: '6px',
    height: '52px',
    fontSize: 16,
    backgroundColor: theme.colors.signInButton.background,
    color: theme.colors.text,
    paddingRight: '0 !important'
  },
  label: {
    marginTop: 'unset',
    fontSize: 10,
    borderRadius: '8px',
    color: theme.colors.textButton,
    backgroundColor: theme.colors.signInButton.background
  },
  root: {
    '& .MuiFormLabel-asterisk': { color: theme.colors.red },
    '& .MuiFilledInput-input': {
      border: `1px solid ${theme.colors.signInButton.background}`,
      color: `${theme.colors.text} !important`,
      backgroundColor: theme.colors.signInButton.background,
      cursor: 'pointer',
      fontSize: '10.7px'
    },
    '& .MuiFilledInput-root.Mui-disabled': {
      backgroundColor: theme.colors.signInButton.background,
      cursor: 'pointer'
    },
    '& .MuiFilledInput-underline:before': {
      border: 'transparent'
    },
    '& .MuiFilledInput-underline:after': {
      border: 'transparent'
    },
    '& .MuiFormHelperText-root': {
      fontSize: '10px'
    },
    '& .MuiFormLabel-root': {
      top: '4px',
      fontSize: '10.7px',
      fontWeight: '400',
      letterSpacing: '0.53px'
    },
    '& .MuiInputBase-input': {
      borderRadius: '6px',
      fontSize: '17.12px'
    },
    '& .MuiInputLabel-root.Mui-required': {
      display: 'flex',
      flexDirection: 'row-reverse'
    },
    '& .MuiInputLabel-root.Mui-error': {
      color: `${theme.colors.fieldName} !important`
    },
    '&.MuiInputLabel-root.Mui-focused': {
      color: theme.colors.fieldName
    },
    '&.MuiInputLabel-root.Mui-animated': {
      color: theme.colors.fieldName
    },
    '.MuiInputAdornment-root': {
      padding: '21px 5px 4px 0px !important'
    },
    '.MuiFormHelperText-root.Mui-error': {
      color: theme.colors.textButton
    },
    marginBottom: '12px'
  },
  input: {
    marginTop: 'unset',
    marginBottom: '12px'
  },
  icon: {
    color: theme.colors.closeIconColor,
    marginRight: '5px'
  },
  menuItem: theme.filtersClasses.menuItem,
  formControl: {
    '& .MuiFormControl-root': {
      margin: 0
    },
    '& .MuiInputBase-input.Mui-disabled': {
      'text-fill-color': 'unset'
    }
  }
}))
